import { render, staticRenderFns } from "./BarNavGeneral.vue?vue&type=template&id=d67fcf68&scoped=true&"
import script from "./BarNavGeneral.vue?vue&type=script&lang=js&"
export * from "./BarNavGeneral.vue?vue&type=script&lang=js&"
import style0 from "./BarNavGeneral.vue?vue&type=style&index=0&id=d67fcf68&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d67fcf68",
  null
  
)

export default component.exports